import Tracking from 'august-ga4-base-tracking';
import { defaultConfig } from '../constants/tracking-config';

let tracking = null;

export function init() {
  if (typeof guidedogsGlobals === 'object' && guidedogsGlobals.isBrightSPage) {
    const disableTrackingFor = [
      'fileDownload',
      'internalLink',
      'formTracking',
      'networkLink',
      'outboundLink',
      'anchor',
      'button',
    ];

    disableTrackingFor.forEach((val) => {
      defaultConfig[val] = {
        disabled: true,
      };
    });
  }

  tracking = new Tracking(defaultConfig);
  return tracking;
}

export function getInstance() {
  if (!tracking) {
    tracking = init();
  }

  return tracking;
}
